import { createContext, Dispatch } from 'react';
import { WorkflowTypes } from '../NewWorkflow/newWorkflowReducer';
import {
  AppState,
  AppAction,
  AppActionKind,
  AppPageKind,
  BuildWorkflow,
  DuplicateWorkflow
} from './types';

export const appReducer = (state: AppState, action: AppAction) => {
  const { type, payload } = action;
  switch (type) {
    case AppActionKind.SET_APPCONTEXT:
      return {
        ...state,
        role: payload as string
      };

    case AppActionKind.SET_APPPAGE:
      return {
        ...state,
        page: payload as AppPageKind
      };

    case AppActionKind.UPDATE_WORKFLOWID:
      return {
        ...state,
        workflowId: payload as string
      };

    case AppActionKind.BUILD_WORKFLOW:
      return {
        ...state,
        ...(payload as BuildWorkflow)
      };

    case AppActionKind.SET_DUPLICATE_WORKFLOW: {
      const { workflowId, workflowName, workflowType } =
        payload as DuplicateWorkflow;
      return {
        ...state,
        page: AppPageKind.DUPLICATE_WORKFLOW,
        workflowId,
        workflowName,
        workflowType
      };
    }

    default:
      return state;
  }
};

export const initialState: AppState = {
  workflowId: '',
  workflowName: '',
  workflowType: WorkflowTypes.OHS,
  role: null,
  page: AppPageKind.LANDING
};

export const AppContext = createContext<{
  state: AppState;
  dispatch: Dispatch<AppAction>;
}>({
  state: initialState,
  dispatch: () => undefined
});
